module.exports = __webpack_public_path__ + "static/img/19.495c29d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/19.png
// module id = dGje
// module chunks = 1